import POST_COMPONENT_TYPE from '../postComponentType';
import StefanZechmannHero from '../../../assets/images/stefan-zechmann-testosterone-check-hero.png';
import { IconType } from '../../../components/BannerWithList';
import { BackgroundColor } from '../../../components/BannerWithTextAndDescription';

const stefanZechmannTestosteroneResults = {
  key: 'testosterone-results',
  sectionList: [
    {
      type: POST_COMPONENT_TYPE.title,
      text: 'learnMoreContent.testosterone-results.name',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextBox,
      image: StefanZechmannHero,
      text: 'learnMoreContent.testosterone-results.banner.text',
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.testosterone-results.whyConsult.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.testosterone-results.whyConsult.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.testosterone-results.whyConsult.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.testosterone-results.whyConsult.listItem3',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.testosterone-results.expectations.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.testosterone-results.expectations.listItem1',
              type: 'text',
            },
            {
              text: 'learnMoreContent.testosterone-results.expectations.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.testosterone-results.expectations.listItem3',
              type: 'text',
            },
            {
              text: 'learnMoreContent.testosterone-results.expectations.listItem4',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.testosterone-results.goodToKnow.title',
      backgroundColor: BackgroundColor.GREEN,
      description: {
        text: 'learnMoreContent.testosterone-results.goodToKnow.description',
        type: 'text',
      },
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithList,
      title: 'learnMoreContent.testosterone-results.howToPrepare.title',
      iconType: IconType.SUCCESS,
      listGroups: [
        {
          items: [
            {
              text: 'learnMoreContent.testosterone-results.howToPrepare.listItem1',
              type: 'textWithLink',
              linkText:
                'learnMoreContent.testosterone-results.howToPrepare.linkText',
              link: 'learnMoreContent.testosterone-results.howToPrepare.url',
            },
            {
              text: 'learnMoreContent.testosterone-results.howToPrepare.listItem2',
              type: 'text',
            },
            {
              text: 'learnMoreContent.testosterone-results.howToPrepare.listItem3',
              type: 'text',
            },
          ],
        },
      ],
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.testosterone-results.secure.title',
      backgroundColor: BackgroundColor.GREEN,
      description: {
        text: 'learnMoreContent.testosterone-results.secure.description',
        type: 'text',
      },
    },
    {
      type: POST_COMPONENT_TYPE.bannerWithTextAndDescription,
      title: 'learnMoreContent.testosterone-results.bookConsultation.title',
      backgroundColor: BackgroundColor.WHITE,
      description: {
        text: 'learnMoreContent.testosterone-results.bookConsultation.description',
        type: 'textWithLink',
        linkText:
          'learnMoreContent.testosterone-results.bookConsultation.linkText',
        link: 'learnMoreContent.testosterone-results.bookConsultation.url',
      },
    },
  ],
};

export default stefanZechmannTestosteroneResults;
